import { VFC } from 'react'
import { BookIcon, BookIconBlue } from 'src/assets/svgs'
import styled from 'styled-components'

type TipsLinkProps = {
  to: string
  color?: 'default' | 'blue'
  align?: 'flex-start' | 'center' | 'flex-end'
  mt?: number
}
export const TipsLink: VFC<TipsLinkProps> = ({
  to,
  color = 'default',
  align = 'center',
  mt,
}) => {
  const tipsLink = {
    default: { code: '#e07b3c', icon: <BookIcon /> },
    blue: { code: '#02B7B0', icon: <BookIconBlue /> },
  }

  return (
    <TipsLinkWrap justifyAlign={align} mt={mt}>
      {tipsLink[color].icon}
      <TipsLinkText color={tipsLink[color].code} href={to} target="_blank">
        活用Tipsはこちら→
      </TipsLinkText>
    </TipsLinkWrap>
  )
}

type TipsLinkWrapStyleProps = {
  justifyAlign: 'flex-start' | 'center' | 'flex-end'
  mt?: number
}
const TipsLinkWrap = styled.div<TipsLinkWrapStyleProps>`
  display: flex;
  margin-top: ${({ mt }) => mt || 0}px;
  justify-content: ${({ justifyAlign }) => justifyAlign};
  align-items: center;
`
type TipsLinkTextStyleProps = {
  color: string
}
const TipsLinkText = styled.a<TipsLinkTextStyleProps>`
  color: ${({ color }) => color};
  font-family: Noto Sans JP;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 7px;
  text-decoration: none;
`
